import React from "react";
import Slider from "react-slick";
import ReactPlayer from "react-player";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import styles from "./GameInfoModal.module.scss";
import VideoPlayer from "components/Utlility/VideoPlayer";

// Same icons as ShopSingle
import timeIcon from "animations/time-black.png";
import playersIcon from "animations/minPlayers-black.png";
import age6Icon from "animations/ageRatings/age-6.png";
import age8Icon from "animations/ageRatings/age-8.png";
import age10Icon from "animations/ageRatings/age-10.png";
import age12Icon from "animations/ageRatings/age-12.png";
import age14Icon from "animations/ageRatings/age-14.png";

const getAgeIcon = (minAge) => {
    switch (minAge) {
        case 6: return age6Icon;
        case 8: return age8Icon;
        case 10: return age10Icon;
        case 12: return age12Icon;
        case 14: return age14Icon;
        default: return age8Icon;
    }
};

const GameInfoModal = ({ show, game, onClose }) => {
    if (!show || !game) return null;

    const previewImages = game.meta?.previewImages;
    const images = [];
    if (previewImages) {
        if (previewImages.mobile1) images.push(previewImages.mobile1);
        if (previewImages.mobile2) images.push(previewImages.mobile2);
        if (previewImages.desktop1) images.push(previewImages.desktop1);
        if (previewImages.desktop2) images.push(previewImages.desktop2);
    }
    if (images.length === 0 && game.meta?.storeCard) {
        images.push(game.meta.storeCard);
    }

    const description = game.gameInfo?.descriptions?.[0]?.body || game.description || "";
    const title = game.gameInfo?.descriptions?.[0]?.header || game.name;
    const duration = game.gameInfo?.avgRoundLengthText;
    const minPlayers = game.gameInfo?.minPlayers;
    const maxPlayers = game.gameInfo?.maxPlayers ?? 8;
    const minAge = game.gameInfo?.minAge;
    const trailerUrl = game.meta?.trailerUrl;
    const trailerVideoUrl = game.meta?.trailerVideoUrl;

    const imageCarouselSettings = {
        dots: true,
        infinite: images.length > 1,
        slidesToShow: 1,
        slidesToScroll: 1,
        arrows: true,
        swipe: true,
        autoplay: false,
    };

    return (
        <div className={`${styles.screenOverlay} ${styles.show}`}>
            <div className={styles.screenOverlayBG} onClick={onClose} />
            <div className={styles.modalContainer}>
                <div className={styles.modal}>
                    <button className={styles.closeBtn} onClick={onClose}>&#10005;</button>

                    {/* Trailer: uploaded MP4 preferred, then external URL (YouTube etc), then image carousel */}
                    {trailerVideoUrl ? (
                        <div className={styles.videoWrapper}>
                            <VideoPlayer key={trailerVideoUrl} src={trailerVideoUrl} autoPlay={show} loop poster={game?.meta?.storeCard} />
                        </div>
                    ) : trailerUrl ? (
                        <div className={styles.videoWrapper}>
                            <div className={styles.reactPlayerWrapper}>
                                <ReactPlayer
                                    url={trailerUrl}
                                    controls
                                    playing={show}
                                    muted={true}
                                    loop={true}
                                    playsinline={true}
                                    width="100%"
                                    height="100%"
                                    className={styles.reactPlayer}
                                />
                            </div>
                        </div>
                    ) : (
                        <div className={styles.imageCarousel}>
                            {images.length > 1 ? (
                                <Slider {...imageCarouselSettings}>
                                    {images.map((img, i) => (
                                        <div key={i} className={styles.slideWrapper}>
                                            <img src={img} alt={`${game.name} preview ${i + 1}`} className={styles.slideImage} />
                                        </div>
                                    ))}
                                </Slider>
                            ) : images.length === 1 ? (
                                <img src={images[0]} alt={game.name} className={styles.singleImage} />
                            ) : null}
                        </div>
                    )}

                    {/* Stats row */}
                    {(duration || minPlayers || minAge) && (
                        <div className={styles.statsRow}>
                            {duration && (
                                <div className={styles.stat}>
                                    <img src={timeIcon} alt="Duration" className={styles.statIcon} />
                                    <span className={styles.statText}>{duration}</span>
                                </div>
                            )}
                            {minPlayers && (
                                <div className={styles.stat}>
                                    <img src={playersIcon} alt="Players" className={styles.statIcon} />
                                    <span className={styles.statText}>
                                        {minPlayers}-{maxPlayers} Players
                                    </span>
                                </div>
                            )}
                            {minAge && (
                                <div className={styles.stat}>
                                    <img src={getAgeIcon(minAge)} alt={`Age ${minAge}+`} className={styles.statIcon} />
                                    <span className={styles.statText}>Age {minAge}+</span>
                                </div>
                            )}
                        </div>
                    )}

                    {/* Content */}
                    <div className={styles.content}>
                        <div className={styles.title}>{title}</div>
                        {description && <p className={styles.description}>{description}</p>}
                    </div>

                    {/* Action buttons */}
                    <div className={styles.actions}>
                        <button className={`${styles.actionBtn} ${styles.buyBtn}`} onClick={onClose}>
                            CLOSE
                        </button>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default GameInfoModal;
